const conditions = () => {
  return [{ projectType: { $ne: '' } }, { assetClass: 'object.asset-class.options.handel-retail' }]
}

export default conditions
